import { useMonetizacionContext } from "../contexts/monetizacion-context";

export default function useMonetizacion(){
    return useMonetizacionContext();
}